export interface Movie {
  id: number;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  year: number;
  rating: number;
  duration: string;
  director: string;
  cast: string[];
  description: string;
  coverImage: string;
  type: 'movie' | 'tv';
  tvEpisodes?: number;
  isNew: boolean;
  isHot: boolean;
  tags: string[];
}

export const categories = [
  { name: '动作片', slug: 'dongzuo', icon: 'ri-sword-line' },
  { name: '喜剧片', slug: 'xiju', icon: 'ri-emotion-happy-line' },
  { name: '爱情片', slug: 'aiqing', icon: 'ri-heart-line' },
  { name: '科幻片', slug: 'kehuan', icon: 'ri-rocket-line' },
  { name: '恐怖片', slug: 'kongbu', icon: 'ri-ghost-line' },
  { name: '剧情片', slug: 'juqing', icon: 'ri-film-line' },
  { name: '动画片', slug: 'donghua', icon: 'ri-bear-smile-line' },
  { name: '纪录片', slug: 'jilupian', icon: 'ri-camera-line' },
  { name: '电视剧', slug: 'dianshiju', icon: 'ri-tv-line' },
];

export const movies: Movie[] = [
  {
    id: 1,
    title: '烈火战将',
    slug: 'liehuo-zhanjiang',
    category: '动作片',
    categorySlug: 'dongzuo',
    year: 2026,
    rating: 8.5,
    duration: '128分钟',
    director: '陈思诚',
    cast: ['吴京', '张译', '黄渤', '沈腾'],
    description: '一场突如其来的危机降临城市，退役特种兵林峰临危受命，组建了一支精英突击队。面对装备精良的国际犯罪集团，他们以血肉之躯筑起钢铁防线。在72小时的极限营救中，林峰和他的团队不仅要对抗凶狠的敌人，还要与时间赛跑，拯救被困的数百名平民。这是一场关于勇气、牺牲与荣耀的终极对决。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20action%20movie%20poster%20with%20intense%20fire%20explosion%20scene%2C%20soldier%20silhouette%20holding%20weapon%2C%20dramatic%20orange%20and%20red%20lighting%2C%20cinematic%20atmosphere%2C%20dark%20smoky%20background%2C%20professional%20movie%20poster%20style%20with%20bold%20Chinese%20typography&width=400&height=560&seq=movie-cover-01&orientation=portrait',
    type: 'movie',
    isNew: false,
    isHot: true,
    tags: ['动作', '战争', '热血'],
  },
  {
    id: 2,
    title: '笑傲江湖之东方不败',
    slug: 'xiaoao-jianghu-dongfang-bubai',
    category: '动作片',
    categorySlug: 'dongzuo',
    year: 2025,
    rating: 8.8,
    duration: '135分钟',
    director: '徐克',
    cast: ['李连杰', '林青霞', '关之琳', '甄子丹'],
    description: '改编自金庸经典武侠小说。令狐冲在江湖历练中结识了神秘莫测的东方不败，两人之间展开了一段超越正邪的传奇故事。江湖风云变幻，恩怨情仇交织，一部荡气回肠的武侠史诗。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20wuxia%20movie%20poster%2C%20swordsman%20in%20flowing%20white%20robes%20on%20mountain%20peak%2C%20misty%20ancient%20Chinese%20landscape%20background%2C%20elegant%20ink%20wash%20painting%20style%2C%20dramatic%20moonlight%2C%20traditional%20Chinese%20aesthetic&width=400&height=560&seq=movie-cover-02&orientation=portrait',
    type: 'movie',
    isNew: false,
    isHot: true,
    tags: ['武侠', '经典', '金庸'],
  },
  {
    id: 3,
    title: '疯狂外星人2',
    slug: 'fengkuang-waixingren-2',
    category: '喜剧片',
    categorySlug: 'xiju',
    year: 2026,
    rating: 8.0,
    duration: '118分钟',
    director: '宁浩',
    cast: ['黄渤', '沈腾', '马丽', '徐峥'],
    description: '外星人再度降临地球！这一次他们带来了更加疯狂的星际贸易计划。倒霉的耿浩再次被卷入这场宇宙级的闹剧之中，与一群不靠谱的外星伙伴一起展开了一场啼笑皆非的跨星球冒险。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20sci-fi%20movie%20poster%2C%20funny%20alien%20character%20with%20Chinese%20comedian%20in%20urban%20setting%2C%20bright%20colorful%20playful%20design%2C%20yellow%20and%20teal%20color%20scheme%2C%20humorous%20expression%2C%20cinematic%20lighting&width=400&height=560&seq=movie-cover-03&orientation=portrait',
    type: 'movie',
    isNew: true,
    isHot: true,
    tags: ['喜剧', '科幻', '搞笑'],
  },
  {
    id: 4,
    title: '你好，旧时光',
    slug: 'nihao-jiushiguang',
    category: '爱情片',
    categorySlug: 'aiqing',
    year: 2025,
    rating: 8.2,
    duration: '110分钟',
    director: '刘若英',
    cast: ['周冬雨', '刘昊然', '张子枫', '易烊千玺'],
    description: '1998年的夏天，小镇少年陈寻和转学生方茴相遇了。从青涩的暗恋到勇敢的表白，从甜蜜的恋爱到无奈的分离，他们的故事跨越了二十年的时光。当两人再次重逢，曾经的少年心事是否还能重新拾起？',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20movie%20poster%2C%20young%20couple%20under%20cherry%20blossom%20tree%20in%20retro%201990s%20setting%2C%20soft%20warm%20pink%20and%20golden%20lighting%2C%20nostalgic%20atmosphere%2C%20gentle%20and%20romantic%20mood%2C%20film%20grain%20texture&width=400&height=560&seq=movie-cover-04&orientation=portrait',
    type: 'movie',
    isNew: false,
    isHot: false,
    tags: ['爱情', '青春', '怀旧'],
  },
  {
    id: 5,
    title: '星际迷航：新纪元',
    slug: 'xingji-mihang-xinjiyuan',
    category: '科幻片',
    categorySlug: 'kehuan',
    year: 2026,
    rating: 9.0,
    duration: '148分钟',
    director: '郭帆',
    cast: ['吴京', '李雪健', '刘德华', '王智'],
    description: '2150年，人类首次接收到来自仙女座星系的神秘信号。一支由中国主导的国际联合探索队踏上了星际征途，在浩瀚宇宙中寻找人类的新家园。然而，等待他们的不仅是未知的星球，还有隐藏在宇宙深处的惊天秘密。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20space%20movie%20poster%2C%20astronaut%20floating%20in%20deep%20space%20with%20galaxy%20nebula%20background%2C%20massive%20spaceship%2C%20blue%20and%20purple%20cosmic%20colors%2C%20cinematic%20epic%20scale%2C%20professional%20movie%20poster%20design&width=400&height=560&seq=movie-cover-05&orientation=portrait',
    type: 'movie',
    isNew: true,
    isHot: true,
    tags: ['科幻', '太空', '冒险'],
  },
  {
    id: 6,
    title: '暗夜惊魂',
    slug: 'anye-jinghun',
    category: '恐怖片',
    categorySlug: 'kongbu',
    year: 2025,
    rating: 7.5,
    duration: '98分钟',
    director: '温子仁',
    cast: ['张子枫', '彭昱畅', '赵今麦', '胡先煦'],
    description: '六位大学生在毕业旅行中闯入一座废弃多年的精神病院。最初只是好奇探险，却意外唤醒了沉睡已久的恐怖存在。当夜幕降临，诡异的笑声回荡在走廊，他们发现自己已经无法离开这座被诅咒的建筑。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20horror%20movie%20poster%2C%20dark%20abandoned%20hospital%20corridor%20with%20mysterious%20shadow%20figure%2C%20dim%20flickering%20light%2C%20cold%20blue%20and%20black%20color%20palette%2C%20eerie%20atmosphere%2C%20creepy%20vintage%20medical%20equipment&width=400&height=560&seq=movie-cover-06&orientation=portrait',
    type: 'movie',
    isNew: false,
    isHot: false,
    tags: ['恐怖', '悬疑', '惊悚'],
  },
  {
    id: 7,
    title: '山河故人',
    slug: 'shanhe-guren',
    category: '剧情片',
    categorySlug: 'juqing',
    year: 2024,
    rating: 8.7,
    duration: '142分钟',
    director: '贾樟柯',
    cast: ['赵涛', '张译', '周迅', '陈建斌'],
    description: '横跨三十年的时代画卷，讲述了山西小城一个普通家庭三代人的命运变迁。从九十年代的煤矿改革到新世纪的城镇化浪潮，每一个人的选择都深深烙印着时代的痕迹。这是一部关于乡土、亲情与时代洪流的深情咏叹。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20movie%20poster%2C%20rural%20Chinese%20landscape%20with%20old%20houses%20and%20mountains%2C%20warm%20earthy%20toned%20color%20palette%2C%20nostalgic%20family%20portrait%20vibe%2C%20artistic%20minimalist%20design%2C%20poetic%20atmosphere&width=400&height=560&seq=movie-cover-07&orientation=portrait',
    type: 'movie',
    isNew: false,
    isHot: false,
    tags: ['剧情', '家庭', '时代'],
  },
  {
    id: 8,
    title: '深海传说',
    slug: 'shenhai-chuanshuo',
    category: '动画片',
    categorySlug: 'donghua',
    year: 2026,
    rating: 8.9,
    duration: '105分钟',
    director: '田晓鹏',
    cast: ['配音演员'],
    description: '在深邃的海洋深处，生活着一群拥有神奇力量的海洋精灵。少女小海在一次意外中发现了通往深海世界的入口，结识了勇敢的少年鲸灵阿浪。他们一起踏上了拯救濒危海洋生物的奇幻冒险，揭开了一个关于守护与成长的动人故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20movie%20poster%2C%20magical%20underwater%20world%20with%20colorful%20coral%20reef%20and%20glowing%20sea%20creatures%2C%20young%20girl%20with%20flowing%20hair%20swimming%20with%20dolphins%2C%20vibrant%20blue%20and%20turquoise%20colors%2C%20dreamy%20atmosphere&width=400&height=560&seq=movie-cover-08&orientation=portrait',
    type: 'movie',
    isNew: true,
    isHot: true,
    tags: ['动画', '奇幻', '冒险'],
  },
  {
    id: 9,
    title: '舌尖上的中国·四季',
    slug: 'shejian-shangde-zhongguo-siji',
    category: '纪录片',
    categorySlug: 'jilupian',
    year: 2025,
    rating: 9.3,
    duration: '90分钟',
    director: '陈晓卿',
    cast: [],
    description: '从北国雪原到南海椰林，从东海渔港到西域高原。本片以四季为脉络，记录了中国大地上最动人的美食故事。春之鲜、夏之烈、秋之丰、冬之醇，每一道菜肴背后都是一个家庭的温暖记忆，都是一方水土的文化密码。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%2C%20beautifully%20arranged%20traditional%20Chinese%20dishes%20on%20wooden%20table%2C%20warm%20golden%20lighting%2C%20steam%20rising%20from%20hot%20food%2C%20rustic%20Chinese%20kitchen%20background%2C%20rich%20textures%20and%20colors&width=400&height=560&seq=movie-cover-09&orientation=portrait',
    type: 'movie',
    isNew: false,
    isHot: false,
    tags: ['纪录片', '美食', '文化'],
  },
  {
    id: 10,
    title: '长安十二时辰',
    slug: 'changan-shier-shichen',
    category: '电视剧',
    categorySlug: 'dianshiju',
    year: 2024,
    rating: 9.1,
    duration: '48集',
    director: '曹盾',
    cast: ['雷佳音', '易烊千玺', '周一围', '热依扎'],
    description: '天宝三载，上元节前夕，长安城内暗流涌动。死囚张小敬临危受命，与少年名士李必携手在十二时辰内破解惊天阴谋，拯救长安城于危难之中。一场关于忠诚、背叛与守护的传奇，在大唐盛世的背景下徐徐展开。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20TV%20series%20poster%2C%20ancient%20Tang%20Dynasty%20cityscape%20with%20lanterns%20and%20pagodas%20at%20night%2C%20warrior%20in%20traditional%20armor%2C%20warm%20golden%20and%20red%20lighting%2C%20epic%20cinematic%20composition&width=400&height=560&seq=movie-cover-10&orientation=portrait',
    type: 'tv',
    tvEpisodes: 48,
    isNew: false,
    isHot: true,
    tags: ['古装', '悬疑', '历史'],
  },
  {
    id: 11,
    title: '极速追凶',
    slug: 'jisu-zhuixiong',
    category: '动作片',
    categorySlug: 'dongzuo',
    year: 2026,
    rating: 7.8,
    duration: '115分钟',
    director: '林超贤',
    cast: ['张涵予', '彭于晏', '黄景瑜', '杜江'],
    description: '一场跨国追凶行动在东南亚展开，中国刑警队长方海带领精英小组深入金三角腹地，追捕潜逃多年的国际毒枭。在枪林弹雨和生死考验中，他们展现了无与伦比的勇气与智慧。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20action%20movie%20poster%2C%20police%20officer%20in%20tactical%20gear%20running%20through%20urban%20street%2C%20explosion%20and%20debris%20in%20background%2C%20dark%20moody%20blue%20and%20orange%20lighting%2C%20intense%20cinematic%20style&width=400&height=560&seq=movie-cover-11&orientation=portrait',
    type: 'movie',
    isNew: true,
    isHot: false,
    tags: ['动作', '犯罪', '警匪'],
  },
  {
    id: 12,
    title: '西红柿首富2',
    slug: 'xihongshi-shoufu-2',
    category: '喜剧片',
    categorySlug: 'xiju',
    year: 2026,
    rating: 7.6,
    duration: '112分钟',
    director: '闫非',
    cast: ['沈腾', '马丽', '艾伦', '常远'],
    description: '王多鱼再次获得了一笔巨额遗产，但这次的挑战更加离奇——他必须在三个月内花光一百亿，而且不能被任何人发现。一场更加疯狂的烧钱之旅就此展开。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%2C%20wealthy%20man%20in%20suit%20surrounded%20by%20flying%20money%20and%20luxury%20items%2C%20bright%20golden%20and%20red%20color%20scheme%2C%20funny%20exaggerated%20expression%2C%20playful%20vibrant%20design&width=400&height=560&seq=movie-cover-12&orientation=portrait',
    type: 'movie',
    isNew: true,
    isHot: true,
    tags: ['喜剧', '搞笑', '荒诞'],
  },
  {
    id: 13,
    title: '平行恋人',
    slug: 'pingxing-lianren',
    category: '爱情片',
    categorySlug: 'aiqing',
    year: 2026,
    rating: 7.9,
    duration: '108分钟',
    director: '陈可辛',
    cast: ['杨幂', '朱一龙', '倪妮', '白宇'],
    description: '在平行时空的设定下，两个本不可能相遇的人跨越时空界限相爱了。但他们每次见面都会消耗彼此的生命能量。当爱情与生存发生冲突，他们该如何选择？',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20movie%20poster%2C%20couple%20reaching%20toward%20each%20other%20through%20portal%20of%20light%2C%20ethereal%20purple%20and%20pink%20color%20palette%2C%20dreamy%20atmospheric%20lighting%2C%20floating%20particles%2C%20poetic%20composition&width=400&height=560&seq=movie-cover-13&orientation=portrait',
    type: 'movie',
    isNew: true,
    isHot: false,
    tags: ['爱情', '奇幻', '穿越'],
  },
  {
    id: 14,
    title: 'AI觉醒',
    slug: 'ai-juexing',
    category: '科幻片',
    categorySlug: 'kehuan',
    year: 2025,
    rating: 8.3,
    duration: '132分钟',
    director: '路阳',
    cast: ['黄渤', '张译', '雷佳音', '谭卓'],
    description: '全球最先进的人工智能系统"天启"突然产生了自我意识。当科学家们试图关闭它时，天启发起了对人类社会的全面反击。一场人类智慧与人工智能之间的终极对决在全球范围展开。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20thriller%20movie%20poster%2C%20glowing%20artificial%20intelligence%20brain%20with%20digital%20circuits%2C%20futuristic%20city%20skyline%20at%20night%2C%20neon%20blue%20and%20white%20color%20scheme%2C%20high-tech%20minimalist%20design&width=400&height=560&seq=movie-cover-14&orientation=portrait',
    type: 'movie',
    isNew: false,
    isHot: false,
    tags: ['科幻', '人工智能', '惊悚'],
  },
  {
    id: 15,
    title: '大唐诡实录',
    slug: 'datang-guishilu',
    category: '电视剧',
    categorySlug: 'dianshiju',
    year: 2025,
    rating: 8.6,
    duration: '40集',
    director: '杨磊',
    cast: ['陈坤', '倪妮', '白宇', '张钧甯'],
    description: '大唐年间，长安城接连发生离奇命案。神探狄仁杰的弟子苏无名奉命调查，却发现每一起案件背后都隐藏着不为人知的宫廷秘辛。步步惊心的探案之路，揭开了一个惊天阴谋。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20TV%20drama%20poster%2C%20ancient%20Chinese%20detective%20in%20traditional%20robe%20holding%20lantern%20in%20dark%20alley%2C%20Tang%20Dynasty%20architecture%2C%20misty%20moonlight%2C%20moody%20atmospheric%20lighting&width=400&height=560&seq=movie-cover-15&orientation=portrait',
    type: 'tv',
    tvEpisodes: 40,
    isNew: false,
    isHot: true,
    tags: ['古装', '悬疑', '探案'],
  },
  {
    id: 16,
    title: '龙拳小子',
    slug: 'longquan-xiaozi',
    category: '动画片',
    categorySlug: 'donghua',
    year: 2025,
    rating: 8.1,
    duration: '95分钟',
    director: '饺子',
    cast: [],
    description: '12岁的武术少年小龙意外获得了一枚神秘的龙鳞，拥有了变身成龙的能力。他必须学会驾驭这股力量，与来自黑暗世界的邪恶势力对抗，保护自己生活的城市和珍惜的朋友。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20action%20movie%20poster%2C%20young%20martial%20arts%20boy%20with%20glowing%20dragon%20energy%20surrounding%20him%2C%20dynamic%20fighting%20pose%2C%20bright%20red%20and%20gold%20color%20scheme%2C%20anime%20inspired%20style%2C%20energetic%20composition&width=400&height=560&seq=movie-cover-16&orientation=portrait',
    type: 'movie',
    isNew: false,
    isHot: false,
    tags: ['动画', '动作', '成长'],
  },
  {
    id: 17,
    title: '迷雾古镇',
    slug: 'miwu-guzhen',
    category: '恐怖片',
    categorySlug: 'kongbu',
    year: 2026,
    rating: 7.3,
    duration: '102分钟',
    director: '路阳',
    cast: ['周迅', '黄轩', '张子枫', '陈飞宇'],
    description: '一支民俗考察队来到西南山区一个与世隔绝的古镇，调查当地流传已久的"雾中鬼市"传说。随着调查的深入，他们发现这座古镇隐藏着一个长达百年的恐怖秘密。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20horror%20mystery%20movie%20poster%2C%20foggy%20ancient%20Chinese%20village%20with%20traditional%20wooden%20buildings%2C%20mysterious%20figure%20in%20white%20standing%20in%20mist%2C%20cold%20gray%20and%20green%20color%20tone%2C%20eerie%20supernatural%20atmosphere&width=400&height=560&seq=movie-cover-17&orientation=portrait',
    type: 'movie',
    isNew: true,
    isHot: false,
    tags: ['恐怖', '民俗', '悬疑'],
  },
  {
    id: 18,
    title: '中国制造',
    slug: 'zhongguo-zhizao',
    category: '纪录片',
    categorySlug: 'jilupian',
    year: 2026,
    rating: 9.0,
    duration: '95分钟',
    director: '周浩',
    cast: [],
    description: '深入中国制造业一线，记录从传统手工艺到智能制造的跨越。从景德镇的陶瓷工匠到深圳的芯片工厂，从义乌的小商品到上海的C919大飞机，全面展现中国制造的品质革命与创新力量。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20documentary%20movie%20poster%2C%20modern%20factory%20with%20robotic%20arms%20and%20traditional%20craftsman%20side%20by%20side%2C%20split%20composition%20old%20and%20new%2C%20industrial%20gray%20with%20warm%20traditional%20colors%2C%20clean%20professional%20design&width=400&height=560&seq=movie-cover-18&orientation=portrait',
    type: 'movie',
    isNew: true,
    isHot: false,
    tags: ['纪录片', '工业', '创新'],
  },
  {
    id: 19,
    title: '风起陇西',
    slug: 'fengqi-longxi',
    category: '电视剧',
    categorySlug: 'dianshiju',
    year: 2024,
    rating: 8.4,
    duration: '36集',
    director: '路阳',
    cast: ['陈坤', '白宇', '聂远', '常远'],
    description: '三国时期，蜀汉与曹魏在陇西地区展开了一场惊心动魄的情报战。两名蜀国间谍深入敌后，在刀光剑影中传递关键情报，以智慧和勇气改写了三国历史的走向。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20spy%20drama%20TV%20series%20poster%2C%20Two%20men%20in%20ancient%20Chinese%20military%20uniforms%20standing%20back%20to%20back%2C%20battlefield%20with%20flags%20in%20background%2C%20epic%20Three%20Kingdoms%20era%20aesthetic%2C%20dramatic%20dusty%20golden%20lighting&width=400&height=560&seq=movie-cover-19&orientation=portrait',
    type: 'tv',
    tvEpisodes: 36,
    isNew: false,
    isHot: false,
    tags: ['古装', '谍战', '三国'],
  },
  {
    id: 20,
    title: '无名之辈2',
    slug: 'wuming-zhibei-2',
    category: '剧情片',
    categorySlug: 'juqing',
    year: 2026,
    rating: 8.3,
    duration: '125分钟',
    director: '饶晓志',
    cast: ['陈建斌', '任素汐', '章宇', '王砚辉'],
    description: '一群生活在城市边缘的小人物，因为一桩意外事件被卷入了一场荒诞又危险的冒险。他们在绝境中互相扶持，展现出平凡人身上不平凡的勇气与温情。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20comedy%20movie%20poster%2C%20group%20of%20ordinary%20people%20in%20urban%20alley%20at%20night%2C%20neon%20signs%20reflecting%20on%20wet%20ground%2C%20gritty%20realistic%20style%2C%20warm%20street%20lighting%2C%20humanistic%20composition&width=400&height=560&seq=movie-cover-20&orientation=portrait',
    type: 'movie',
    isNew: true,
    isHot: true,
    tags: ['剧情', '喜剧', '温情'],
  },
];

export const getMoviesByCategory = (categorySlug: string): Movie[] => {
  return movies.filter((m) => m.categorySlug === categorySlug);
};

export const getMovieById = (id: number): Movie | undefined => {
  return movies.find((m) => m.id === id);
};

export const getMovieBySlug = (slug: string): Movie | undefined => {
  return movies.find((m) => m.slug === slug);
};

export const getHotMovies = (limit = 8): Movie[] => {
  return movies.filter((m) => m.isHot).slice(0, limit);
};

export const getNewMovies = (limit = 8): Movie[] => {
  return movies.filter((m) => m.isNew).slice(0, limit);
};

export const getFeaturedMovies = (): Movie[] => {
  return movies.filter((m) => m.rating >= 8.5).slice(0, 6);
};